import "../styles/components/_loader.scss";

export const Loader = () => {
  return <span className="loader"></span>;
};
